import { formatFilterLabelWithCount } from "@widgets/CampaignBrief/lib/campaignBriefFilterFacetCounts";
import { useBriefInfluencerFilterStore } from "@widgets/CampaignBrief/store/useBriefInfluencerFilterStore";
import { SearchMultiSelectFilter } from "@shared/ui/filters/SearchMultiSelectFilter";

interface BriefCommercialStatusFilterOption {
  label: string;
  value: string;
}

interface BriefCommercialStatusFilterProps {
  confirm: () => void;
  close: () => void;
  options: BriefCommercialStatusFilterOption[];
  getOptionCount?: (value: string) => number | undefined;
  searchPlaceholder?: string;
  before?: React.ReactNode;
}

export function BriefCommercialStatusFilter({
  confirm,
  close,
  options,
  getOptionCount,
  searchPlaceholder = "Search status",
  before,
}: BriefCommercialStatusFilterProps) {
  const { feFilters, setFilters, saveFilters } =
    useBriefInfluencerFilterStore();

  const selectedValues = options
    .filter(
      (option) =>
        feFilters.statusFilters?.[
          option.value as keyof typeof feFilters.statusFilters
        ]
    )
    .map((option) => option.value);

  const handleApply = (values: string[]) => {
    const newStatusFilters = { ...feFilters.statusFilters };

    options.forEach((option) => {
      newStatusFilters[option.value as keyof typeof newStatusFilters] =
        values.includes(option.value);
    });

    setFilters({
      ...feFilters,
      statusFilters: newStatusFilters,
    });
    saveFilters();
  };

  return (
    <SearchMultiSelectFilter
      confirm={confirm}
      close={close}
      before={before}
      options={options.map((option) => ({
        label: formatFilterLabelWithCount(
          option.label,
          getOptionCount?.(option.value)
        ),
        value: option.value,
      }))}
      selectedValues={selectedValues}
      onApply={handleApply}
      searchPlaceholder={searchPlaceholder}
    />
  );
}
